import { render } from "./TZModal.vue?vue&type=template&id=c4440576&scoped=true"
import script from "./TZModal.vue?vue&type=script&lang=js"
export * from "./TZModal.vue?vue&type=script&lang=js"

import "./TZModal.vue?vue&type=style&index=0&id=c4440576&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4440576"]])

export default __exports__